/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';
import { isProd, isLocal } from '../env/environment'

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig: Configuration = {
    auth: {
      clientId: isProd() ? "bd30fb69-ef5e-49c4-9691-95ecfdf0af8e" : "90aa5a29-9245-4568-a752-befed6eb7673",
      authority: isProd() ? "https://cqgauth.b2clogin.com/cqgauth.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_PASSWORDLESS_ONLY": "https://cqgauthdev.b2clogin.com/cqgauthdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_PASSWORDLESS_ONLY",
      knownAuthorities: isProd() ?  ["cqgauth.b2clogin.com"]: ["cqgauthdev.b2clogin.com"],
      redirectUri: isLocal() ? 'http://localhost:3000' : isProd() ? 'https://content.cqg.ai': 'https://content.dev.cqg.ai', 
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii || isProd()) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
    authority: isProd() ? 'https://cqgauth.b2clogin.com/cqgauth.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_PASSWORDLESS_ONLY': "https://cqgauthdev.b2clogin.com/cqgauthdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_PASSWORDLESS_ONLY",
    redirectUri: isLocal() ? 'http://localhost:3000' : isProd() ? 'https://admin.pacy.ai': 'https://admin.dev.pacy.ai', 
    scopes: [ "openid", "offline_access" ],
};